import { useLayoutEffect, useState } from 'react';

// useDocument still returns the previous document, with loading false, in the
// render right after its path changed. That render does not count as loaded.
const useLoadedFor = (key: string, loading: boolean) => {
  const [settled, setSettled] = useState(key);

  // A layout effect re-renders within the same commit, and React runs
  // useDocument's unsubscribe before that render. A passive effect would leave
  // a gap in which a late snapshot of the old path ends the loading state.
  useLayoutEffect(() => setSettled(key), [key]);

  return settled === key && !loading;
};

export default useLoadedFor;
